<script setup lang="ts">
import BootstrapCard from '@/components/bootstrap/BootstrapCard.vue';
import Profile from '@/pages/(home)/account/content/profile.vue';

definePage({ name: 'AccountProfile', meta: { title: 'account.tabs.profile' } });
</script>

<template>
  <h5>{{ $t('account.tabs.profile') }}</h5>
  <Suspense>
    <Profile />

    <template #fallback>
      <div>
        <BootstrapCard :shimmer="true" :shimmer-height="200" class="mb-3" />

        <div class="row">
          <div class="col-12 col-xxl-6 mb-2 mb-xxl-0">
            <BootstrapCard :shimmer="true" :shimmer-height="80" :header-text="$t('labels.roles')" />
          </div>
          <div class="col-12 col-xxl-6">
            <BootstrapCard :shimmer="true" :shimmer-height="80" :header-text="$t('labels.stations')" />
          </div>
        </div>
      </div>
    </template>
  </Suspense>
</template>

<style scoped>

</style>